define('banner/custom-banners/trial-expire',['require','durandal/app','api-access','api-access','moment','lodash','lib/models/account/is-marvel-account','i18next'],function (require) {
    var app = require('durandal/app');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var moment = require('moment');
    var _ = require('lodash');
    var isMarvelAccount = require('lib/models/account/is-marvel-account');
    var i18n = require('i18next');

    return {
        initialize: function (findExpiringTrial, checkMeetingsAfterDate) {
            var options = {
                id: 'trial-end-notification',
                classes: 'alert-warning',
                iconClasses: 'togo-icon togo-icon-alert',
                disableTime: 60 * 60 * 1000
            };

            var fetchInitialData = function () {
                var fetching = $.Deferred();

                userApi.me().then(function (user) {
                    commerceApi.getProducts()
                        .then(function (products) {
                            fetching.resolve(user, products);
                        })
                        .fail(function () {
                            fetching.reject();
                        });
                });

                return fetching.promise();
            };

            var triggerBanner = function (postTrialMeetingType, isBillingAdmin, willAccountPersist) {
                var i18nKey;

                if (postTrialMeetingType === 'ORGANIZER') {
                    if (isBillingAdmin) {
                        if (willAccountPersist) {
                            i18nKey = 'trial.expires.futureMeetingsForAdmin';
                        } else {
                            i18nKey = 'trial.expires.lessThan5DaysLeft.withFutureMeetingsForAdmin';
                        }
                    } else {
                        if (willAccountPersist) {
                            i18nKey = 'trial.expires.futureMeetingsForOrganizer';
                        } else {
                            i18nKey = 'trial.expires.lessThan5DaysLeft.withFutureMeetingsForOrganizer';
                        }
                    }
                } else if (postTrialMeetingType === 'ACCOUNT') {
                    if (willAccountPersist) {
                        i18nKey = 'trial.expires.futureMeetingsForAccount';
                    } else {
                        i18nKey = 'trial.expires.lessThan5DaysLeft.withFutureMeetingsForAccount';
                    }
                }

                if (i18nKey) {
                    options.message = i18n.t(i18nKey);
                    app.trigger('banner:addOne', options);
                }
            };

            fetchInitialData().then(function (user, products) {
                var expiringTrial = findExpiringTrial(products, moment().endOf('day').add(5, 'd'));
                var isMarvel = isMarvelAccount(products);

                if (expiringTrial && !isMarvel) {
                    var isBillingAdmin = user.key === expiringTrial.billingAdminUserKey;
                    var endDate = moment(expiringTrial.endDate);
                    var seats = expiringTrial.seats;

                    var persistingTrialNames = ['G2M_Basic_Trial', 'G2M_Pro_Trial'];
                    var willAccountPersist = _.includes(persistingTrialNames, expiringTrial.name);

                    checkMeetingsAfterDate(endDate, isBillingAdmin, seats)
                        .then(_.partialRight(triggerBanner, isBillingAdmin, willAccountPersist));
                }
            });
        }
    };
});

